import React from 'react'
import { sortReplies } from '@btime/helpers'
import { gql } from '@apollo/client'

import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import { serviceOrdersClient } from '../../../../utils/apollo/api'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder
export const useReplies = () => {
  const replies = useServiceOrder()?.replies || []
  return sortReplies(replies)
}

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      metadata
      formReplyId
      parentId
      events {
        id
        eventDate
        status {
          id
          name
          color
        }
        description
      }
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      scheduling
      customerCode
      internalCode
      invoice
      description
      user {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
        type
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      checklist {
        id
        name
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          nonComplianceConditions
          documents {
            id
            src
            type
            description
          }
          description
          reference
          parentReference
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, id }) => {
  const permalinkToken = usePermalinkToken()

  let { data, ...state } = useQuery(QUERY, {
    variables: { id, permalinkToken: permalinkToken },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrder}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
